// @flow

import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';
import { getActiveAccessoriesIdsByMethod } from './accessories';
import { getActiveBundleId } from './bundles';
import { getActiveClaimFreeId } from './claimFree';
import { getActiveColorId } from './color';
import { getActiveDurationId } from './duration';
import { getActiveExtraContractsIdsByMethod } from './extraContracts';
import { getActiveMileageId } from './mileage';
import { getActivePackageId } from './package';
import { getActivePdbId } from '../../../pdb';
import { getStockResultId } from '../../../orderForm/selectors';
import type { State as RouterState } from '../../../router/types';
import { getIsActive as vbmrIsActive } from '../../vbmr/selectors';

type GlobalState = {
  configuration: ConfigState,
  configuratorSettings: any,
  pdb: PdbState,
  orderForm: OrderFormState,
  router: RouterState,
};

export const getConfiguration = (state: GlobalState) => ({
  pdbId: getActivePdbId(state),
  offer: false,
  duration: getActiveDurationId(state),
  mileage: getActiveMileageId(state),
  package: getActivePackageId(state),
  color: getActiveColorId(state),
  accessories: getActiveAccessoriesIdsByMethod(state, 'selected', true),
  contracts: getActiveExtraContractsIdsByMethod(state, 'selected', true),
  extra_bundles: [getActiveBundleId(state)],
  claim_free: getActiveClaimFreeId(state),
  stockId: getStockResultId(state),
  vbmr: vbmrIsActive(state),
});

export default null;
